import React from "react";
import Navbar, { WhatsAppIcon } from "../components/Navbar";
import BrandBadge from "../components/BrandBadge";
import CookieConsent from "../components/CookieConsent";
import FloatingChannels from "../components/FloatingChannels";
import FeaturedBrands from "../components/FeaturedBrands";
import { api } from "../api";

const LandingPage = ({ site, loading }) => {
  if (loading) {
    return (
      <div className="App dot-grid min-h-screen flex items-center justify-center">
        <div className="w-12 h-12 rounded-full border-4 border-[#25D366]/30 border-t-[#25D366] animate-spin" />
      </div>
    );
  }

  const heading = site?.heading || `Connect with ${site?.name || "us"} on WhatsApp`;
  const accent = site?.accentColor || "#f6c453";

  const glowStyle = {
    background: `radial-gradient(circle, ${accent}2e 0%, ${accent}12 35%, rgba(18,19,31,0) 70%)`,
  };

  const handleClick = () => {
    // Fire-and-forget analytics; does not block opening WhatsApp.
    if (site?.id) api.recordClick(site.id).catch(() => {});
  };

  return (
    <div className="App dot-grid min-h-screen relative overflow-hidden">
      <Navbar downloadUrl={site?.downloadUrl || "#"} />
      <div className="hero-glow" style={glowStyle} />

      <main className="relative z-10 flex flex-col items-center justify-center px-5 pt-24 pb-8 sm:pt-28 sm:pb-14 sm:min-h-screen">
        <div className="fade-in-up">
          <a href={site?.whatsappUrl || "#"} target="_blank" rel="noopener noreferrer" onClick={handleClick}>
            <BrandBadge site={site} />
          </a>
        </div>

        <h1 className="font-display font-semibold text-xl sm:text-2xl text-white mt-8 sm:mt-10 text-center fade-in-up">
          {heading}
        </h1>

        <a
          href={site?.whatsappUrl || "#"}
          target="_blank"
          rel="noopener noreferrer"
          onClick={handleClick}
          className="wa-btn wa-ping mt-7 inline-flex items-center gap-3 bg-[#25D366] hover:bg-[#1fb757] text-white font-display font-semibold text-base sm:text-lg px-8 py-4 rounded-full fade-in-up"
        >
          <WhatsAppIcon className="w-6 h-6" />
          Continue to Chat
        </a>

        <p className="mt-6 text-sm text-[#25D366] text-center fade-in-up">
          {site?.subtext || "Tap to open WhatsApp and start chatting instantly"}
        </p>
      </main>

      <FeaturedBrands site={site} />

      <CookieConsent />
      <FloatingChannels site={site} />
    </div>
  );
};

export default LandingPage;
